<template>
  <el-collapse :value="['1']">
    <MyCollapse iconPath="/static/de-zmr.png" title="费用填写审核记录" name="1">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)">
        <el-table-column prop="apprNodeName" width="150" label="节点名称">
        </el-table-column>
        <el-table-column prop="apprStatusName" width="120" label="流程状态">
          <template v-slot="scope">
            {{ scope.row.apprStatus == 1 ? '提交' :  scope.row.apprStatusName}}
          </template>
        </el-table-column>
        <el-table-column prop="apprUserName" width="200" label="经办人">
        </el-table-column>
        <el-table-column prop="apprTime" width="160" label="处理时间">
          <template v-slot="scope">
            {{ parseTime(scope.row.apprTime, '{y}-{m}-{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column prop="apprOpinion" label="意见说明" align="left">
        </el-table-column>
      </el-table>
    </MyCollapse>
  </el-collapse>
</template>

<script>
import { getApprLogByOutlayId } from "@/util/api";
import MyCollapse from '@/components/business/MyCollapse'
import dialogPanel from "@/components/business/dialogPanel";

export default {
  components: {
    dialogPanel,
    MyCollapse
  },
  props: {
    outlayId: String,
  },
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  mounted () {
    this.queryList();
  },
  methods: {
    queryList () {
      if (this.outlayId) {
        this.loading = true;
        getApprLogByOutlayId({
          outlayId: this.outlayId
        }).then((res) => {
          this.tableData = res.responseData;
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common.scss";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/view/OutlayHistory.vue